<template>
  <div>
    <v-card outlined tile elevation="0" class="rounded-lg ma-4">
      <v-sheet :class="showCard ? '' : 'rounded-lg'" color="primary">
        <v-card-title class="pa-2 card-title-height">
          <v-btn icon elevation="0" class="" @click="showCard = !showCard">
            <v-icon color="white">
              {{
                showCard ? "mdi-chevron-up" : "mdi-chevron-down"
              }}
            </v-icon>
          </v-btn>
          <div class="text-body-1 ml-2 white--text">Préférences de contact</div>
          <v-spacer />
        </v-card-title>
      </v-sheet>
      <v-expand-transition>
        <div v-if="loading">
          <v-progress-linear indeterminate color="primary" />
          <v-skeleton-loader class="mb-4" type="list-item-three-line" />
        </div>
        <div v-else v-show="showCard">
          <v-card-text class="grey lighten-4">
            <div>
              <span
                v-if="!content.iresa_confiance"
                class="subtitle-1"
              >
                Les communications ne seront envoyées que si la confiance est active
              </span>
              <v-switch
                v-model="newsletters.labalaguere_newsletter.status"
                class="mt-2"
                dense
                :label="labels['labalaguere_newsletter']"
              />
            </div>
            <div> 
              <span>Date de dernière modification: {{ newsletters.labalaguere_newsletter.dataConsentDate }}</span>
            </div>
          </v-card-text>
          <div v-if="isEditingContactPreferences">
            <v-divider />
            <v-card-text class="d-flex justify-end">
              <v-btn :disabled="loading" color="secondary" elevation="0" class="mx-2 px-4" @click="saveNewsletters()">
                <v-icon class="mr-3">mdi-content-save</v-icon>
                Enregistrer
              </v-btn>
            </v-card-text>
          </div>
        </div>
      </v-expand-transition>
    </v-card>
  </div>
</template>

<script>

const _ = require('lodash');

export default {
  name: 'ContactPreferencesCardLaBalaguere',
  components: { },
  props: {
    content: {
      type: Object,
      default: null
    },
    saveCustomer: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      showCard: true,
      newsletters: JSON.parse(JSON.stringify(this.content.newsletters)),
      labels: { labalaguere_newsletter: 'Accepte de recevoir des communication de la part de La Balaguère' }
    };
  },
  computed: {
    isEditingContactPreferences () {
      return !this.compareNewsletters(this.newsletters, this.content.newsletters);
    }
  },
  methods: {
    async saveNewsletters () {
      this.loading = true;
      const editableContent = { ...this.content };
      // LB NEWSLETTERS

      editableContent.newsletters.labalaguere_newsletter = this.newsletters.labalaguere_newsletter.status;

      delete editableContent.newsletters.ucpa_last_update_time;
      delete editableContent.newsletters.loisirs_last_update_time;

      await this.saveCustomer(editableContent);

      this.newsletters = JSON.parse(JSON.stringify(this.content.newsletters));
      this.loading = false;
    },
    compareNewsletters(newslettersA, newslettersB){
      return !newslettersA.labalaguere_newsletter.status === !newslettersB.labalaguere_newsletter.status;
    }
  }
};

</script>
